import { DRONE_EXTENSION_ENABLED } from '../static/constants.js';
import { WithDroneComponentTrackingForForwarded, WithDroneComponentTrackingForNormal } from './hoc/WithDroneComponentTracking.js';
import { isQueryParamExist } from './isQueryParamExist.js';

var trackForwardedComponent = function trackForwardedComponent(Component) {
  var WrappedComponent = isQueryParamExist(DRONE_EXTENSION_ENABLED) ? WithDroneComponentTrackingForForwarded(Component) : Component;
  return WrappedComponent;
};
var trackNormalComponent = function trackNormalComponent(Component) {
  var WrappedComponent = isQueryParamExist(DRONE_EXTENSION_ENABLED) ? WithDroneComponentTrackingForNormal(Component) : Component;
  return WrappedComponent;
};

export { trackForwardedComponent, trackNormalComponent };
//# sourceMappingURL=trackComponent.js.map
